// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResearchTimeline_section__9b5ib {
  padding-block: 1rem;
}

.ResearchTimeline_section__9b5ib h2 {
  margin: 0.5rem 0 2rem;
}

.ResearchTimeline_stops__-cPyj {
  position: relative;
  display: grid;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.ResearchTimeline_stops__-cPyj::before {
  content: "";
  position: absolute;
  background: var(--primary);
  width: 2px;
  top: 0;
  bottom: 0;
  left: 20px;
  transform-origin: top;
}

.ResearchTimeline_stop__7K9oG {
  position: relative;
  padding-left: 3.75rem;
  min-width: 0;
}

.ResearchTimeline_node__UNZf7 {
  position: absolute;
  left: 0;
  top: 0;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 2px solid var(--primary);
  border-radius: 50%;
  background: var(--bg);
  color: var(--primary);
  font-weight: 700;
  box-sizing: border-box;
}

.ResearchTimeline_live__DUyDK {
  background: var(--primary);
  color: white;
}

.ResearchTimeline_stop__7K9oG h3 {
  font-size: 1.25rem;
  margin: 0.5rem 0;
}

.ResearchTimeline_meta__eZZ\\+x {
  color: var(--text-secondary);
  font-size: 0.9375rem;
}

.ResearchTimeline_stop__7K9oG ul {
  padding-left: 1.2rem;
  margin-block: 0.75rem;
}

.ResearchTimeline_stop__7K9oG li + li {
  margin-top: 0.75rem;
}

.ResearchTimeline_stop__7K9oG summary {
  min-height: 44px;
  padding-block: 0.75rem;
  box-sizing: border-box;
  cursor: pointer;
  color: var(--primary);
  font-weight: 600;
}

@media (min-width: 1024px) {
  .ResearchTimeline_stops__-cPyj {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1.75rem;
  }

  .ResearchTimeline_stops__-cPyj::before {
    width: auto;
    height: 2px;
    left: 20px;
    right: 20px;
    top: 20px;
    bottom: auto;
    transform-origin: left;
  }

  .ResearchTimeline_stop__7K9oG {
    padding: 3.5rem 0 0;
  }

  .ResearchTimeline_stop__7K9oG:nth-child(even) {
    padding-top: 5.5rem;
  }
}

@supports (animation-timeline: view()) {
  @media (prefers-reduced-motion: no-preference) {
    .ResearchTimeline_stops__-cPyj::before {
      animation: ResearchTimeline_drawVertical__9tvE0 linear both;
      animation-timeline: view();
      animation-range: entry 10% cover 60%;
    }
  }

  @media (min-width: 1024px) and (prefers-reduced-motion: no-preference) {
    .ResearchTimeline_stops__-cPyj::before {
      animation-name: ResearchTimeline_drawHorizontal__NhoNV;
    }
  }
}

@keyframes ResearchTimeline_drawHorizontal__NhoNV {
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}

@keyframes ResearchTimeline_drawVertical__9tvE0 {
  from {
    transform: scaleY(0);
  }

  to {
    transform: scaleY(1);
  }
}

@media (max-width: 560px) {
  .ResearchTimeline_section__9b5ib h2 {
    margin-bottom: 1.25rem;
  }

  .ResearchTimeline_stops__-cPyj {
    gap: 1.5rem;
  }

  .ResearchTimeline_stops__-cPyj::before {
    left: 15px;
  }

  .ResearchTimeline_stop__7K9oG {
    padding-left: 3rem;
  }

  .ResearchTimeline_node__UNZf7 {
    width: 32px;
    height: 32px;
    font-size: 0.875rem;
  }

  .ResearchTimeline_stop__7K9oG h3 {
    font-size: 1.0625rem;
    margin: 0.25rem 0;
  }

  .ResearchTimeline_meta__eZZ\\+x {
    font-size: 0.8125rem;
  }

  .ResearchTimeline_stop__7K9oG ul {
    margin-block: 0.5rem;
    font-size: 0.875rem;
  }

  .ResearchTimeline_stop__7K9oG li + li {
    margin-top: 0.375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Research/ResearchTimeline.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE;MACE,2DAAmC;MACnC,0BAA0B;MAC1B,oCAAoC;IACtC;EACF;;EAEA;IACE;MACE,sDAA8B;IAChC;EACF;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".section {\n  padding-block: 1rem;\n}\n\n.section h2 {\n  margin: 0.5rem 0 2rem;\n}\n\n.stops {\n  position: relative;\n  display: grid;\n  gap: 2rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.stops::before {\n  content: \"\";\n  position: absolute;\n  background: var(--primary);\n  width: 2px;\n  top: 0;\n  bottom: 0;\n  left: 20px;\n  transform-origin: top;\n}\n\n.stop {\n  position: relative;\n  padding-left: 3.75rem;\n  min-width: 0;\n}\n\n.node {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border: 2px solid var(--primary);\n  border-radius: 50%;\n  background: var(--bg);\n  color: var(--primary);\n  font-weight: 700;\n  box-sizing: border-box;\n}\n\n.live {\n  background: var(--primary);\n  color: white;\n}\n\n.stop h3 {\n  font-size: 1.25rem;\n  margin: 0.5rem 0;\n}\n\n.meta {\n  color: var(--text-secondary);\n  font-size: 0.9375rem;\n}\n\n.stop ul {\n  padding-left: 1.2rem;\n  margin-block: 0.75rem;\n}\n\n.stop li + li {\n  margin-top: 0.75rem;\n}\n\n.stop summary {\n  min-height: 44px;\n  padding-block: 0.75rem;\n  box-sizing: border-box;\n  cursor: pointer;\n  color: var(--primary);\n  font-weight: 600;\n}\n\n@media (min-width: 1024px) {\n  .stops {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 1.75rem;\n  }\n\n  .stops::before {\n    width: auto;\n    height: 2px;\n    left: 20px;\n    right: 20px;\n    top: 20px;\n    bottom: auto;\n    transform-origin: left;\n  }\n\n  .stop {\n    padding: 3.5rem 0 0;\n  }\n\n  .stop:nth-child(even) {\n    padding-top: 5.5rem;\n  }\n}\n\n@supports (animation-timeline: view()) {\n  @media (prefers-reduced-motion: no-preference) {\n    .stops::before {\n      animation: drawVertical linear both;\n      animation-timeline: view();\n      animation-range: entry 10% cover 60%;\n    }\n  }\n\n  @media (min-width: 1024px) and (prefers-reduced-motion: no-preference) {\n    .stops::before {\n      animation-name: drawHorizontal;\n    }\n  }\n}\n\n@keyframes drawHorizontal {\n  from {\n    transform: scaleX(0);\n  }\n\n  to {\n    transform: scaleX(1);\n  }\n}\n\n@keyframes drawVertical {\n  from {\n    transform: scaleY(0);\n  }\n\n  to {\n    transform: scaleY(1);\n  }\n}\n\n@media (max-width: 560px) {\n  .section h2 {\n    margin-bottom: 1.25rem;\n  }\n\n  .stops {\n    gap: 1.5rem;\n  }\n\n  .stops::before {\n    left: 15px;\n  }\n\n  .stop {\n    padding-left: 3rem;\n  }\n\n  .node {\n    width: 32px;\n    height: 32px;\n    font-size: 0.875rem;\n  }\n\n  .stop h3 {\n    font-size: 1.0625rem;\n    margin: 0.25rem 0;\n  }\n\n  .meta {\n    font-size: 0.8125rem;\n  }\n\n  .stop ul {\n    margin-block: 0.5rem;\n    font-size: 0.875rem;\n  }\n\n  .stop li + li {\n    margin-top: 0.375rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ResearchTimeline_section__9b5ib`,
	"stops": `ResearchTimeline_stops__-cPyj`,
	"stop": `ResearchTimeline_stop__7K9oG`,
	"node": `ResearchTimeline_node__UNZf7`,
	"live": `ResearchTimeline_live__DUyDK`,
	"meta": `ResearchTimeline_meta__eZZ+x`,
	"drawVertical": `ResearchTimeline_drawVertical__9tvE0`,
	"drawHorizontal": `ResearchTimeline_drawHorizontal__NhoNV`
};
export default ___CSS_LOADER_EXPORT___;
